module["exports"] = ["ديزل", "كهربائي", "بنزين", "هجين"];
